/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_UsedInputs */

const vi_product_classification_used = /** @type {(inputs: Product_Classification_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã dùng (kg)`)
};

/**

* @param {Product_Classification_UsedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_used = /** @type {((inputs?: Product_Classification_UsedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_UsedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_used(inputs)
});